// This file is auto-generated

import nlNL from './ottonl/nl-NL.json';

const messages = { 'nl-NL': nlNL };

export default messages;
